module.exports = __webpack_public_path__ + "static/media/EnvelopeSimple.55418b96.svg";